import Header from "../header";
import TaskBar from "../taskbar";
import { Link } from "react-router-dom";
import "./index.css"
import ddabroadorg from "../../assests/images/ddabroadorg.png"
import CopyRight from "../copyright";



const ContactUS = () => {

    return (

        <>
          <Header />
          <div className="container-head">
            <h2>Contact US</h2>
           <img  src={ddabroadorg}  className="sizelogo" alt="logo"/>
           <p>Call Us: +44 7900 345127 | 7386770284 | 7702846678 | +1 778-636-9959</p>
           <p>Email : info@ddabroad.in</p>
           <Link to="/applynow" className="hero-btn">
          Apply Now
        </Link>
           <p>Dream Bigger. Achieve Greater. With Dream Destination</p>
          </div>
          <TaskBar />
          <CopyRight />
        </>
    )

}

export default ContactUS